var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowConverter = function SvgArrowConverter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M.438 39.83C10.5 35.06 18.5 36.558 23.796 43.167c2.746 4.467-2.223 11.94-5.29 10.834-1.733-.62-1.866-2.786-1.022-4.422 2.622-5.041 10.52-10.315 20.954-10.315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    d: "m35.872 42.633 3.106-3.455L35.582 36"
  })));
};
export default SvgArrowConverter;